<hh-cast-layout [layout]="layout$$()">
  <ng-container [ngSwitch]="widgets$$()">
    <ng-container *ngSwitchCase="'devices'">
      <hh-health-charts-widget />
      <hh-kitchen-information-widget />
      <hh-samsung-health-overview-widget />
      <hh-security-cameras-widget />
    </ng-container>

    <ng-container *ngSwitchCase="'telehealth'">
      <hh-video-call-widget />
      <hh-health-records-widget />
      <hh-samsung-health-overview-widget />
    </ng-container>

    <ng-container *ngSwitchCase="'dining'">
      <hh-restaurant-header-widget restaurant="bella-vita" />
      <hh-restaurant-header-widget restaurant="chop-house" />
      <hh-restaurant-menu-widget />
      <hh-restaurant-menu-widget />
    </ng-container>

    <ng-container *ngSwitchCase="'family'">
      <hh-family-call-widget />
    </ng-container>
  </ng-container>

</hh-cast-layout>
